"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TemperatureSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,2 C9.88071187,2 11,3.11928813 11,4.5 L11.0010266,10.0515567 C11.6190155,10.6827339 12,11.5468751 12,12.5 C12,14.4329966 10.4329966,16 8.5,16 C6.56700338,16 5,14.4329966 5,12.5 C5,11.5466052 5.38120037,10.6822445 5.99949854,10.0510205 L6,4.5 C6,3.11928813 7.11928813,2 8.5,2 Z M8.5,3 C7.67157288,3 7,3.67157288 7,4.5 L7.00004507,10.4997831 C6.39279608,10.9558841 6,11.6820708 6,12.5 C6,13.8807119 7.11928813,15 8.5,15 C9.88071187,15 11,13.8807119 11,12.5 C11,11.6825273 10.6076422,10.9566946 10.0009713,10.5005469 L10,4.5 C10,3.67157288 9.32842712,3 8.5,3 Z M9,5 L9.00070296,11.0856015 C9.58293192,11.2917181 10,11.8471533 10,12.5 C10,13.3284271 9.32842712,14 8.5,14 C7.67157288,14 7,13.3284271 7,12.5 C7,11.8467813 7.41754351,11.2910851 8.00029246,11.0852495 L8,5 L9,5 Z" })));
};
TemperatureSmall.displayName = 'TemperatureSmall';
exports.default = TemperatureSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TemperatureSmall.js.map